import { useStore } from 'zustand';
import { session, SessionState } from './session';

export type { AuthMode } from './authMode';
export type { RequestAuth, SessionStatus } from './adapters';
export type { LegacySignIn, SessionState } from './session';
export { session };

export const useSession = <T>(selector: (state: SessionState) => T) =>
  useStore(session.store, selector);
